import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-10 border border-neutral-200">
        <div className="flex items-center gap-3 mb-8">
          <span className="inline-flex items-center justify-center w-10 h-10 bg-[#003F88] text-white">
            <Lock size={18} />
          </span>
          <div>
            <div className="font-serif-display text-2xl text-neutral-900">Acesso interno</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-neutral-500">Equipe Rosalvo</div>
          </div>
        </div>

        {err && (
          <div data-testid="admin-login-error" className="mb-5 p-3 bg-red-50 border-l-4 border-red-500 text-sm text-red-800">
            {err}
          </div>
        )}

        <label className="block mb-5">
          <span className="text-[11px] uppercase tracking-[0.22em] text-neutral-500">E-mail</span>
          <input
            data-testid="admin-login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full bg-transparent border-b border-neutral-300 py-3 focus:border-[#003F88] outline-none"
          />
        </label>
        <label className="block mb-8">
          <span className="text-[11px] uppercase tracking-[0.22em] text-neutral-500">Senha</span>
          <input
            data-testid="admin-login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full bg-transparent border-b border-neutral-300 py-3 focus:border-[#003F88] outline-none"
          />
        </label>
        <button
          data-testid="admin-login-submit"
          disabled={loading}
          type="submit"
          className="w-full bg-[#003F88] text-white px-6 py-4 text-xs uppercase tracking-[0.2em] font-medium hover:bg-[#002A5C] transition-colors disabled:opacity-60"
        >
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
